/**
 * What the inventory screen cannot say inline: `:hover`, and the `@keyframes`
 * the container search's animations need. Concatenated into the HUD's single
 * `<style>` block (`hud.tsx`).
 */
export const INVENTORY_CSS = `
.equipment-doll {
  position: relative;
  isolation: isolate;
  display: grid;
  grid-template-columns: repeat(4, 86px);
  grid-template-rows: 80px 96px 80px 80px;
  grid-template-areas:
    ". helmet helmet ."
    "rig vest vest backpack"
    "weapon1 weapon1 weapon1 pistol"
    "weapon2 weapon2 weapon2 .";
  gap: 8px;
  width: 368px;
  min-width: 368px;
  padding: 2px;
  box-sizing: border-box;
}
.equipment-slot {
  position: relative;
  z-index: 1;
  display: flex;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(177, 184, 180, .25);
  border-radius: 2px;
  background: rgba(12, 15, 15, .83);
  box-shadow: 0 4px 12px rgba(0, 0, 0, .28);
}
.equipment-slot-helmet {
  width: 86px;
}
.equipment-slot-label {
  position: relative;
  z-index: 2;
  flex: 0 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 0 5px;
  color: rgba(226, 232, 227, .78);
  background: linear-gradient(90deg, rgba(73, 84, 81, .94), rgba(31, 37, 36, .94));
  border-bottom: 1px solid rgba(193, 201, 196, .18);
  font: 600 9px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: .055em;
  text-transform: uppercase;
  white-space: nowrap;
}
.equipment-slot-label kbd {
  display: grid;
  place-items: center;
  min-width: 13px;
  height: 13px;
  padding: 0 2px;
  color: rgba(242, 238, 214, .9);
  border: 1px solid rgba(224, 216, 174, .32);
  border-radius: 2px;
  background: rgba(0, 0, 0, .34);
  font: 600 9px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}
.equipment-slot-well {
  position: relative;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  outline-offset: -2px;
  background:
    repeating-linear-gradient(135deg, rgba(126, 139, 135, .045) 0 5px, transparent 5px 10px),
    rgba(19, 23, 23, .8);
}
.equipment-slot-empty {
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .28);
}
.equipment-slot-watermark {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: rgba(190, 199, 193, .12);
  font: 600 9px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: .08em;
  text-transform: uppercase;
  pointer-events: none;
}
@media (max-height: 760px) {
  .equipment-doll {
    grid-template-rows: 68px 82px 70px 70px;
    gap: 6px;
  }
  .equipment-slot-label {
    flex-basis: 16px;
    font-size: 8px;
  }
}
.invclose {
  font: 15px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  color: rgba(227, 234, 241, 0.7);
  background: transparent;
  border: 1px solid rgba(214, 205, 194, 0.22);
  border-radius: 3px;
  width: 20px;
  height: 20px;
  padding: 0;
  cursor: pointer;
}
.invclose:hover {
  color: #f4f8fc;
  background: rgba(196, 84, 72, 0.35);
  border-color: rgba(232, 104, 92, 0.6);
}
.invtake {
  font: 11px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: 0.04em;
  color: rgba(227, 234, 241, 0.7);
  background: transparent;
  border: 1px solid rgba(214, 205, 194, 0.22);
  border-radius: 3px;
  padding: 5px 8px;
  cursor: pointer;
}
.invtake:hover {
  color: #f4f8fc;
  background: rgba(96, 124, 156, 0.38);
  border-color: rgba(150, 178, 210, 0.55);
}
.invmenu-item {
  display: block;
  width: 100%;
  text-align: left;
  font: 12px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  color: #e3eaf1;
  background: transparent;
  border: 0;
  border-radius: 3px;
  padding: 6px 8px;
  cursor: pointer;
}
.invtake:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.invtake:disabled:hover {
  color: rgba(227, 234, 241, 0.7);
  background: transparent;
  border-color: rgba(214, 205, 194, 0.22);
}
.invmenu-item:hover {
  background: rgba(96, 124, 156, 0.38);
}
/* The Werkbank uses the same icon tiles as the inventory. Slot names remain as
   small mount labels; item names live in native tooltips instead of competing
   with the atlas art. */
.modslot {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: left;
  font: 12px/1.25 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  color: #e3eaf1;
  background: transparent;
  border: 0;
  border-radius: 3px;
  padding: 0;
  cursor: pointer;
  min-width: 0;
}
.modslot:hover {
  filter: brightness(1.12);
}
.modslot-label {
  color: rgba(210, 222, 232, 0.58);
  font: 9px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.modslot-item {
  position: relative;
  flex: 1;
  min-height: 0;
  border: 1px dashed rgba(214, 205, 194, 0.24);
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.3);
}
.modslot-empty {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: rgba(210, 222, 232, 0.3);
  font: 20px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}
.modparts {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.modpart {
  position: relative;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(214, 205, 194, 0.2);
  border-radius: 3px;
  padding: 0;
  cursor: pointer;
}
.modpart:hover {
  background: rgba(96, 124, 156, 0.34);
  border-color: rgba(150, 178, 210, 0.5);
}
.modcallout {
  position: absolute;
  z-index: 2;
  width: 52px;
  height: 44px;
  padding: 0;
  border: 1px solid rgba(146, 170, 190, 0.42);
  border-radius: 2px;
  background: rgba(13, 17, 21, 0.82);
  cursor: pointer;
}
.modcallout:hover,
.modcallout-active {
  border-color: rgba(192, 215, 232, 0.78);
  background: rgba(59, 78, 94, 0.88);
}
.moddrop-valid {
  outline: 2px solid rgba(130, 215, 143, 0.96) !important;
  outline-offset: -2px;
  box-shadow: 0 0 15px rgba(100, 200, 118, 0.28);
}
.moddrop-invalid {
  outline: 2px solid rgba(226, 91, 82, 0.96) !important;
  outline-offset: -2px;
  box-shadow: 0 0 15px rgba(210, 70, 64, 0.24);
}
.modsource-dragging {
  opacity: .34;
}
.modstat-track {
  position: relative;
  display: block;
  height: 12px;
  overflow: hidden;
  border: 1px solid rgba(173, 183, 188, 0.38);
  background: rgba(0, 0, 0, 0.72);
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.7);
}
.modstat-fill {
  display: block;
  height: 100%;
  min-width: 2px;
}
.moddialog-handle {
  flex: 0 0 34px;
  min-width: 0;
  display: grid;
  /* Title, whatever the screen wants to say about the gun (a price, usually),
     and the close button. The middle column collapses when there is no
     header. */
  grid-template-columns: 1fr auto 24px;
  align-items: center;
  gap: 10px;
  padding: 0 8px 0 12px;
  border-bottom: 1px solid rgba(214, 205, 194, 0.22);
  background: rgba(11, 14, 15, 0.96);
  font: 10px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: .08em;
  cursor: move;
  touch-action: none;
}
.moddialog-resize {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
  cursor: nwse-resize;
  touch-action: none;
  background:
    linear-gradient(135deg, transparent 48%, rgba(190, 202, 209, .34) 49% 55%, transparent 56%),
    linear-gradient(135deg, transparent 66%, rgba(190, 202, 209, .55) 67% 73%, transparent 74%);
}
/* --- Container search (see inventory/search.ts) -------------------------- */
/* The lid on an unsearched crate. A sibling of the grid rather than a child,
   so it also hides the drop area from zoneAt — see screen.tsx. */
.invsearch-cover {
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid rgba(214, 205, 194, .18);
  border-radius: 3px;
  background: rgba(10, 12, 14, .88);
  cursor: pointer;
  transition: background 140ms ease, border-color 140ms ease;
}
.invsearch-cover:hover {
  background: rgba(20, 24, 28, .84);
  border-color: rgba(214, 205, 194, .38);
}
.invsearch-cover-title {
  color: rgba(190, 199, 193, .5);
  font: 600 11px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: .18em;
  text-transform: uppercase;
}
.invsearch-cover-hint {
  color: rgba(190, 199, 193, .28);
  font: 9px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: .08em;
}
/* A magnifier drawn out of two borders: a ring, and a bar rotated 45° off its
   lower right. No glyph, so it does not change shape with the player's fonts. */
.invsearch-glass {
  position: relative;
  width: 22px;
  height: 22px;
  border: 2px solid rgba(198, 208, 202, .5);
  border-radius: 50%;
}
.invsearch-glass::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 100%;
  width: 2px;
  height: 9px;
  margin-left: -1px;
  background: rgba(198, 208, 202, .5);
  transform: rotate(-45deg);
  transform-origin: top center;
}
.invsearch-hidden {
  animation: invsearch-pulse 1.6s ease-in-out infinite alternate;
}
/* The lens itself glides: left/top are written per reveal and the transition
   draws the path between two items. */
.invsearch-lens {
  border: 2px solid rgba(226, 214, 168, .78);
  border-radius: 50%;
  background: radial-gradient(circle at 38% 34%, rgba(255, 250, 225, .16), rgba(255, 250, 225, .03) 62%, transparent 68%);
  box-shadow: 0 0 14px rgba(226, 214, 168, .3), inset 0 0 10px rgba(226, 214, 168, .16);
  transition: left 320ms ease, top 320ms ease;
  animation: invsearch-wobble 1.5s ease-in-out infinite alternate;
}
.invsearch-lens::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 100%;
  width: 3px;
  height: 15px;
  margin-left: -1.5px;
  border-radius: 2px;
  background: rgba(226, 214, 168, .78);
  transform: rotate(-45deg);
  transform-origin: top center;
}
.invsearch-reveal {
  animation: invsearch-reveal 260ms ease-out both;
}
@keyframes invsearch-pulse {
  from { opacity: .65; }
  to { opacity: 1; }
}
@keyframes invsearch-wobble {
  from { transform: rotate(-7deg); }
  to { transform: rotate(7deg); }
}
@keyframes invsearch-reveal {
  from { opacity: 0; transform: scale(.86); }
  to { opacity: 1; transform: scale(1); }
}
`;
